import Vue from 'vue';
import Router from 'vue-router';
import Browse from '@/components/Browse';
import mBrowse from '@/components/mBrowse';
import SignUp from '@/components/SignUp';
import ViewMinistryRequest from '@/components/ViewMinistryRequest';
import AdminHome from '@/components/AdminHome';
import FileUpload from '@/components/FileUpload';
import ApprovalResponse from '@/components/ApprovalResponse';
import ViewNotification from '@/components/ViewNotification';
import SystemConfig from '@/components/SystemConfig';
import DirectMessageResponse from '@/components/DirectMessageResponse';
import MySignUp from '@/components/MySignUp';
import AdminLogin from '@/components/AdminLogin';
import Account from '@/components/Account';
import EditMRAccess from '@/components/EditMRAccess';
import ChangePassword from '@/components/ChangePassword';
import UploadRole from '@/components/UploadRole';
import MLSignUp from '@/components/MLSignUp';
import Report from '@/components/Report';

Vue.use(Router)

export default new Router({
  routes: [
    {
      path:'/report',
      name:'Report',
      component: Report
    },
    {
      path:'/mlsignup',
      name:'MLSignUp',
      component: MLSignUp
    },
    {
      path:'/mbrowse',
      name:'mBrowse',
      component: mBrowse
    },
    {
      path:'/uploadrole',
      name:'UploadRole',
      component: UploadRole
    },
    {
      path:'/changepassword',
      name:'ChangePassword',
      component: ChangePassword
    },
    {
      path: '/editmraccess',
      name: 'EditMRAccess',
      component: EditMRAccess
    },
    {
      path: '/account',
      name: 'Account',
      component: Account
    },
    {
      path: '/adminlogin',
      name: 'AdminLogin',
      component: AdminLogin
    },
    {
      path: '/',
      name: 'Browse',
      component: Browse
    },
    {
      path: '/signup',
      name: 'SignUp',
      component: SignUp
    },
    {
      path: '/ministryrequests',
      name: 'ViewMinistryRequest',
      component: ViewMinistryRequest
    },
    {
      path: '/adminhome',
      name: 'AdminHome',
      component: AdminHome
    },
    {
      path: '/fileupload',
      name: 'FileUpload',
      component: FileUpload
    },
    {
      path: '/approvalresponse',
      name: 'ApprovalResponse',
      component: ApprovalResponse
    },
    {
      path: '/notification',
      name: 'ViewNotification',
      component: ViewNotification
    },
    {
      path: '/systemconfig',
      name: 'SystemConfig',
      component: SystemConfig
    },
    {
      path: '/directmessageresponse',
      name: 'DirectMessageResponse',
      component: DirectMessageResponse
    },
    {
      path: '/mysignup',
      name: 'MySignUp',
      component: MySignUp
    }
  ]
})
